import type { IUploadsState } from './uploads.types';

export const SLICE_NAMESPACE = 'downloads-uploads/uploads';

export const initialState: IUploadsState = {
  list: {
    loading: false,
    uploads: [],
  },
  form: {
    loading: false,
    success: false,
  },
  upload: {
    loading: false,
    success: false,
    result: {
      date: '',
      filePath: '',
      templateUrl: '',
      userName: '',
      filename: '',
    },
  },
};
